import { makeAutoObservable } from "mobx";
import { ICompareValueStore } from "./compare-value-factory";
import ReturnReasonCompareValueField from "../../components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/condition-field/compare-value-type-fields/return-reason-compare-value-field";
import { IReturnReasonPreset } from "../../policy-types";
import { ICompareValueNumber, ensureValidNumber } from "./integer-compare-value-store";


class ReturnReasonCompareValueStore implements ICompareValueStore<number|undefined> {
    private _model: ICompareValueNumber = {} as ICompareValueNumber;
    private _changes: Partial<ICompareValueNumber> = {};
    private _uncommittedChanges: Partial<ICompareValueNumber> = {};

    constructor(private _returnReasonPresets?: IReturnReasonPreset[], compareValue?: string) {
        makeAutoObservable(this);
        if (compareValue) {
            this._model = { value: ensureValidNumber(compareValue) };
        }
    }

    public onOperatorChanged(): void {
    }

    public setChanges(changes?: string) {
        if (changes) {
            this._changes = { value: ensureValidNumber(changes) };
        }
    }

    get Component() {
        return ReturnReasonCompareValueField;
    }

    get returnReasonOptions() {
        return this._returnReasonPresets?.map(reason => ({
            value: reason.id,
            label: reason.display_name,
            disabled: !reason.is_enabled
        }))
    }

    public get value() {
        return this._uncommittedChanges.value ?? this._changes.value ?? this._model.value;
    }

    public setValue(v: number) {
        this._uncommittedChanges.value = v;
    }

    public commitChanges(): void {
        this._changes = {...this._changes, ...this._uncommittedChanges};
        this._clearUnneededChanges();
    }

    public discardUncommittedChanges(): void {
        this._uncommittedChanges = {};
    }

    public hasChanges(): boolean {
        return !!Object.values(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public getUpdatedModel(): string|undefined {
        const updated = { ...this._model, ...this._changes };
        return updated.value?.toString();
    }

    public getUncommittedChanges(): number|undefined {
        return { ...this._model, ...this._changes, ...this._uncommittedChanges }?.value;
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof ICompareValueNumber;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default ReturnReasonCompareValueStore;
